export default __webpack_public_path__ + "static/media/condenser_use1.bca3de0b.png";